export function PageLoader() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: '3px solid var(--ink-200)',
          borderTopColor: 'var(--brand-pink)',
          animation: 'spin 0.7s linear infinite',
        }}
      />
    </div>
  )
}
